import { combineReducers } from "redux";

import { user } from "./User";
import { merchant } from "./Merchant";
import { medias } from "./Medias";
import { customPage } from "./CustomPage";

const reducers = combineReducers({
  user,
  merchant,
  medias,
  customPage,
});

export default reducers;
